import React, { useContext } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { ViewContext } from "./contexts/ViewContext";
import wheelchallengeImage from "./images/wheelchallenge.jpg";
import StoreIcon from "@mui/icons-material/Store";
import PanToolIcon from "@mui/icons-material/PanTool";

export default function Home() {
    const { view, dispatch } = useContext(ViewContext);

    return (
        <div>
            <img
                src={wheelchallengeImage}
                alt="wheelchallenge"
                style={{ width: "100%" }}
            />
            <List>
                <ListItem
                    button
                    selected={view.page === "poi-select"}
                    key="poi"
                    to={"/hu/poi"}
                    onClick={() =>
                        dispatch({
                            type: "CHANGE PAGE",
                            pageType: "poi",
                            direction: 1,
                        })
                    }
                >
                    <ListItemIcon>
                        <StoreIcon />
                    </ListItemIcon>
                    <ListItemText
                        primary={
                            view.locale === "hu"
                                ? "Hely értékelése"
                                : view.locale === "en" && "Assess a venue"
                        }
                    />
                </ListItem>
                <ListItem
                    button
                    selected={view.page === "obstacle"}
                    key="obstacle"
                    to={"/hu/obstacle"}
                    onClick={() =>
                        dispatch({
                            type: "CHANGE PAGE",
                            pageType: "obstacle",
                            direction: 1,
                        })
                    }
                >
                    <ListItemIcon>
                        <PanToolIcon />
                    </ListItemIcon>
                    <ListItemText
                        primary={
                            view.locale === "hu"
                                ? "Akadály jelentése"
                                : view.locale === "en" && "Report an obstacle"
                        }
                    />
                </ListItem>
            </List>
        </div>
    );
}
